import {utils} from '@bsky.app/alf'

export const BLUE_HUE = 211

/**
 * @deprecated use `utils.alpha` from `@bsky.app/alf` instead
 */
export const transparentifyColor = utils.alpha
